let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("etHNI")).then(() => parcelRequire('5M5EC'));